import {
  Link,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from '@mui/material';
import React from 'react';
import { DailyStats } from '../room/types';
import { utcToLocalDate } from '../room/utils';

type PropTypes = {
  dailyStats?: DailyStats[];
};

export const DailyStatsTable = ({ dailyStats }: PropTypes) => {
  return (
    <>
      <Typography
        id="modal-modal-title"
        variant="h5"
        component="h2"
        mb={2}
        textAlign="center"
      >
        Daily Stats (Games Played Per Day)
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
        <Table stickyHeader size="small" aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Date (UTC)</TableCell>
              <TableCell>Solo</TableCell>
              <TableCell>Match</TableCell>
              <TableCell>SnG</TableCell>
              <TableCell>SnG (by players)</TableCell>
              <TableCell>Total Games</TableCell>
              <Tooltip title="solo + match x 2 + sng x numOfPlayers">
                <TableCell>True Total Games</TableCell>
              </Tooltip>
            </TableRow>
          </TableHead>
          <TableBody>
            {dailyStats?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{utcToLocalDate(row.date)}</TableCell>
                <TableCell>{row.numOfSoloGamesPlayed}</TableCell>
                <TableCell>{row.numOfMatchGamesPlayed}</TableCell>
                <TableCell>{row.numOfSitAndGoGamesPlayed}</TableCell>
                <TableCell>{row.numOfSitAndGoGamesPlayedPerPlayer}</TableCell>
                <TableCell>
                  {(row.numOfSoloGamesPlayed || 0) +
                    (row.numOfMatchGamesPlayed || 0) +
                    (row.numOfSitAndGoGamesPlayed || 0)}
                </TableCell>
                <TableCell>
                  {(row.numOfSoloGamesPlayed || 0) +
                    (row.numOfMatchGamesPlayed * 2 || 0) +
                    (row.numOfSitAndGoGamesPlayedPerPlayer || 0)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
